import { ACTION_TYPES } from "../actions/albumTrack";
import { initialState } from "./initialState";

export const albumTrack = (state = initialState.albumTrack, action) => {
    switch (action.type) {
        case ACTION_TYPES.FETCH_ALL_SONGS_BY_ALBUM:
            return {
                ...state,
                list: [...action.payload.sort((a, b) => a['trackNo'] - b['trackNo'])]
            };
        case ACTION_TYPES.CREATE_SONG:
            return {
                ...state,
                list: [...state.list, action.payload]
            };
        case ACTION_TYPES.UPDATE_SONG:
            return {
                ...state,
                list: state.list.map(x => x.id === action.payload.id ? action.payload : x)
            };
        case ACTION_TYPES.DELETE_SONG:
            return {
                ...state,
                list: state.list.filter(x => x.id !== action.payload)
            };
        default:
            return state;
    }
}